var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_vm._v("\n  name: "+_vm._s(_vm.knowledge_process.name)),_c('br'),_vm._v("\n  description: "+_vm._s(_vm.knowledge_process.description)+"\n  "),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }